import _objectSpread from "/Users/ismaelgoncalves/Documents/Projetos/front_nuts/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$firstSelected, _vm$firstSelected2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-6"
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v("Gestão de Contratos")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'contratosServicosNovo'
        });
      }
    }
  }, [_c('i', {
    staticClass: "la la-file-contract mr-2"
  }), _vm._v(" Novo Contrato ")])], 1), _vm.currentUser.admin ? _c('b-row', {
    staticClass: "mb-6"
  }, [_c('b-col', {
    staticClass: "mb-4 d-flex",
    attrs: {
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "card card-custom shadow-sm w-100 h-100"
  }, [_c('div', {
    staticClass: "card-body d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Total no período")]), _c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v(_vm._s(_vm.totalPeriodoLabel))]), _vm.loadingKpis ? [_c('b-skeleton', {
    staticClass: "mt-1",
    attrs: {
      "width": "60px",
      "height": "28px"
    }
  })] : [_c('div', {
    staticClass: "font-weight-bolder h4 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.kpis.totalJanela) + " ")])]], 2), _c('i', {
    staticClass: "la la-calendar-check-o icon-2x"
  })])])]), _c('b-col', {
    staticClass: "mb-4 d-flex",
    attrs: {
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "card card-custom shadow-sm w-100 h-100"
  }, [_c('div', {
    staticClass: "card-body d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Ativos")]), _vm.loadingKpis ? [_c('b-skeleton', {
    staticClass: "mt-1",
    attrs: {
      "width": "60px",
      "height": "28px"
    }
  })] : [_c('div', {
    staticClass: "font-weight-bolder h4 mb-0"
  }, [_vm._v(_vm._s(_vm.kpis.ativos))])]], 2), _c('i', {
    staticClass: "la la-check-circle icon-2x"
  })])])]), _c('b-col', {
    staticClass: "mb-4 d-flex",
    attrs: {
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "card card-custom shadow-sm w-100 h-100"
  }, [_c('div', {
    staticClass: "card-body d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.aVencerLabel))]), _vm.loadingKpis ? [_c('b-skeleton', {
    staticClass: "mt-1",
    attrs: {
      "width": "60px",
      "height": "28px"
    }
  })] : [_c('div', {
    staticClass: "font-weight-bolder h4 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.kpis.aVencer30) + " ")])]], 2), _c('i', {
    staticClass: "la la-hourglass-half icon-2x"
  })])])]), _c('b-col', {
    staticClass: "mb-4 d-flex",
    attrs: {
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "card card-custom shadow-sm w-100 h-100"
  }, [_c('div', {
    staticClass: "card-body d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Vencidos")]), _vm.loadingKpis ? [_c('b-skeleton', {
    staticClass: "mt-1",
    attrs: {
      "width": "60px",
      "height": "28px"
    }
  })] : [_c('div', {
    staticClass: "font-weight-bolder h4 mb-0 text-danger"
  }, [_vm._v(" " + _vm._s(_vm.kpis.vencidos) + " ")])]], 2), _c('i', {
    staticClass: "la la-times-circle icon-2x"
  })])])])], 1) : _vm._e(), _c('div', {
    staticClass: "card card-custom mb-3"
  }, [_c('div', {
    staticClass: "card-body py-2 px-3"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyFilters.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    staticClass: "align-items-center",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    staticClass: "pr-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-input-group', {
    staticClass: "w-auto",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    staticClass: "wch-28",
    attrs: {
      "placeholder": "Cliente / CPF/CNPJ",
      "inputmode": "search",
      "autocomplete": "off",
      "trim": ""
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "title": "Limpar"
    },
    on: {
      "click": function click($event) {
        _vm.searchTerm = '';
      }
    }
  }, [_c('i', {
    staticClass: "la la-times"
  })])], 1)], 1)], 1), _c('b-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-select', {
    staticClass: "wch-16",
    attrs: {
      "options": _vm.statusOptions,
      "size": "sm"
    },
    model: {
      value: _vm.filters.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "status", $$v);
      },
      expression: "filters.status"
    }
  })], 1), _c('b-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-select', {
    staticClass: "wch-28",
    attrs: {
      "options": _vm.vendedorOptions,
      "disabled": _vm.loadingVendedores,
      "size": "sm",
      "aria-label": "Filtrar por vendedor"
    },
    model: {
      value: _vm.filters.id_vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "id_vendedor", $$v);
      },
      expression: "filters.id_vendedor"
    }
  })], 1), _c('b-col', {
    staticClass: "px-2 d-flex align-items-center",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-datepicker', {
    staticClass: "mr-2 wch-14",
    attrs: {
      "size": "sm",
      "date-format-options": {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      },
      "placeholder": "Início",
      "reset-button": false
    },
    model: {
      value: _vm.filters.dateFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "dateFrom", $$v);
      },
      expression: "filters.dateFrom"
    }
  }), _c('span', {
    staticClass: "mx-1"
  }, [_vm._v("—")]), _c('b-form-datepicker', {
    staticClass: "ml-2 wch-14",
    attrs: {
      "size": "sm",
      "date-format-options": {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      },
      "placeholder": "Fim",
      "reset-button": false
    },
    model: {
      value: _vm.filters.dateTo,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "dateTo", $$v);
      },
      expression: "filters.dateTo"
    }
  }), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "p-0 ml-2",
    attrs: {
      "size": "sm",
      "variant": "link",
      "title": "Limpar período"
    },
    on: {
      "click": _vm.clearDateRange
    }
  }, [_c('i', {
    staticClass: "la la-eraser"
  })])], 1), _c('b-col', {
    staticClass: "pl-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "la la-search mr-1"
  }), _vm._v(" Filtrar ")])], 1)], 1), _vm.filters.dateFrom || _vm.filters.dateTo ? _c('small', {
    staticClass: "text-muted d-none d-md-inline ml-2"
  }, [_vm._v(" " + _vm._s(_vm.periodLabel) + " ")]) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "card card-custom"
  }, [_vm.selectedCount > 0 ? _c('div', {
    staticClass: "alert alert-primary d-flex justify-content-between align-items-center mb-3"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.selectedCount))]), _vm._v(" contrato(s) selecionado(s). ")]), _c('div', {
    staticClass: "btn-group"
  }, [_vm.canExecuteSelected ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.openExecuteModal(_vm.firstSelected);
      }
    }
  }, [_c('i', {
    staticClass: "la la-play mr-1"
  }), _vm._v(" Executar agora ")]) : _vm._e(), _vm.currentEmpresaId == 1 ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": _vm.openAtivarLicencaModal
    }
  }, [_c('i', {
    staticClass: "la la-check mr-1"
  }), _vm._v(" Ativar licença ")]) : _vm._e(), _vm.canActivateSelected ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('confirm-bulk-ativar');
      }
    }
  }, [_c('i', {
    staticClass: "la la-check mr-1"
  }), _vm._v(" Ativar ")]) : _vm._e(), _vm.currentEmpresaId == 1 ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('confirm-bulk-congelar');
      }
    }
  }, [_c('i', {
    staticClass: "la la-snowflake-o mr-1"
  }), _vm._v(" Congelar contrato ")]) : _vm._e(), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openAlterarDiaModal
    }
  }, [_c('i', {
    staticClass: "la la-calendar mr-1"
  }), _vm._v(" Alterar dia de cobrança ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": _vm.openAlterarDiaEnvioModal
    }
  }, [_c('i', {
    staticClass: "la la-send mr-1"
  }), _vm._v(" Alterar dia de envio ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('confirm-bulk-cancelar');
      }
    }
  }, [_c('i', {
    staticClass: "la la-ban mr-1"
  }), _vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v(" Limpar seleção ")])], 1)]) : _vm._e(), _c('b-modal', {
    attrs: {
      "cancel-title": "Cancelar",
      "id": "confirma-dia-cobranca",
      "title": "Alterar dia de cobrança",
      "centered": "",
      "ok-disabled": !_vm.diaCobrancaForm.day || _vm.diaCobrancaLoading,
      "ok-title": _vm.diaCobrancaLoading ? 'Salvando...' : 'Confirmar',
      "cancel-disabled": _vm.diaCobrancaLoading,
      "busy": _vm.diaCobrancaLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleAlterarDiaCobranca.apply(null, arguments);
      },
      "hidden": _vm.resetDiaCobrancaModal
    }
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Você vai alterar o dia de cobrança de "), _c('strong', [_vm._v(_vm._s(_vm.selectedCount))]), _vm._v(" contrato(s). ")]), _c('b-form-group', {
    attrs: {
      "label": "Novo dia de cobrança"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dayOptions
    },
    model: {
      value: _vm.diaCobrancaForm.day,
      callback: function callback($$v) {
        _vm.$set(_vm.diaCobrancaForm, "day", $$v);
      },
      expression: "diaCobrancaForm.day"
    }
  }), _c('small', {
    staticClass: "text-muted d-block mt-2"
  }, [_vm._v(" Se o mês não tiver o dia escolhido, a cobrança ocorrerá no último dia disponível do mês. ")])], 1)], 1), _c('b-modal', {
    attrs: {
      "cancel-title": "Cancelar",
      "id": "confirma-dia-envio-fatura",
      "title": "Alterar dia de envio da fatura",
      "centered": "",
      "ok-disabled": !_vm.diaEnvioFaturaForm.day || _vm.diaEnvioFaturaLoading,
      "ok-title": _vm.diaEnvioFaturaLoading ? 'Salvando...' : 'Confirmar',
      "cancel-disabled": _vm.diaEnvioFaturaLoading,
      "busy": _vm.diaEnvioFaturaLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleAlterarDiaEnvioFatura.apply(null, arguments);
      },
      "hidden": _vm.resetDiaEnvioFaturaModal
    }
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Você vai alterar o dia de envio da fatura de "), _c('strong', [_vm._v(_vm._s(_vm.selectedCount))]), _vm._v(" contrato(s). ")]), _c('b-form-group', {
    attrs: {
      "label": "Novo dia de envio da fatura"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dayOptions
    },
    model: {
      value: _vm.diaEnvioFaturaForm.day,
      callback: function callback($$v) {
        _vm.$set(_vm.diaEnvioFaturaForm, "day", $$v);
      },
      expression: "diaEnvioFaturaForm.day"
    }
  }), _c('small', {
    staticClass: "text-muted d-block mt-2"
  }, [_vm._v(" Se o mês não tiver o dia escolhido, a fatura será enviada no último dia disponível do mês. ")])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "confirm-bulk-cancelar",
      "title": "Confirmar cancelamento",
      "centered": "",
      "ok-disabled": _vm.cancelLoading,
      "ok-title": _vm.cancelLoading ? 'Cancelando...' : 'Sim, cancelar',
      "ok-variant": "danger",
      "cancel-title": "Cancelar",
      "cancel-disabled": _vm.cancelLoading,
      "busy": _vm.cancelLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleCancelar.apply(null, arguments);
      },
      "hidden": function hidden($event) {
        _vm.cancelLoading = false;
      }
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" Tem certeza que deseja "), _c('strong', [_vm._v("cancelar")]), _vm._v(", após cancelar os boletos em abertos serão cancelados. "), _c('strong', [_vm._v(" " + _vm._s(_vm.selectedCount))]), _vm._v(" contrato(s) selecionado(s)? ")])]), _c('b-modal', {
    attrs: {
      "cancel-title": "Cancelar",
      "id": "confirm-bulk-ativar",
      "title": "Confirmar ativação",
      "centered": "",
      "ok-disabled": _vm.confirmLoading,
      "ok-title": _vm.confirmLoading ? 'Ativando...' : 'Sim, ativar',
      "ok-variant": 'success',
      "cancel-disabled": _vm.confirmLoading,
      "busy": _vm.confirmLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleConfirmAtivar.apply(null, arguments);
      }
    }
  }, [_vm._v(" Tem certeza que deseja ativar os contratos selecionados? ")]), _c('b-modal', {
    attrs: {
      "cancel-title": "Cancelar",
      "id": "confirm-bulk-congelar",
      "title": "Confirmar congelamento do contrato",
      "centered": "",
      "ok-disabled": _vm.confirmLoading,
      "ok-title": _vm.confirmLoading ? 'Congelando...' : 'Sim, congelar',
      "ok-variant": 'success',
      "cancel-disabled": _vm.confirmLoading,
      "busy": _vm.confirmLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleConfirmCongela.apply(null, arguments);
      }
    }
  }, [_vm._v(" Tem certeza que deseja congelar os contratos selecionados? ")]), _c('b-modal', {
    attrs: {
      "id": "confirm-execute-contract",
      "title": "Executar contrato agora",
      "centered": "",
      "ok-disabled": _vm.executeLoading,
      "cancel-disabled": _vm.executeLoading,
      "busy": _vm.executeLoading,
      "ok-title": _vm.executeLoading ? 'Executando...' : 'Sim, executar agora',
      "ok-variant": "success",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleExecuteNow.apply(null, arguments);
      },
      "hidden": _vm.resetExecuteModal
    }
  }, [_vm.executionTarget ? _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" O contrato "), _c('strong', [_vm._v("#" + _vm._s(_vm.executionTarget.numero))]), _vm._v(" de "), _c('strong', [_vm._v(_vm._s(_vm.executionTarget.cliente))]), _vm._v(" será faturado agora. ")]) : _vm._e(), _c('div', {
    staticClass: "alert alert-light-primary mb-3"
  }, [_vm._v(" A NFS-e e a cobrança serão geradas para a competência vigente: "), _c('strong', [_vm._v(_vm._s(_vm.currentCompetenciaLabel))]), _vm._v(". ")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Esta ação poderá emitir a NFS-e e gerar o boleto configurado. Se já existir uma cobrança ativa nesta competência, nada será gerado novamente e você receberá um aviso. ")])]), _c('b-modal', {
    attrs: {
      "id": "generate-period-boletos-modal",
      "title": "Gerar boletos do período",
      "centered": "",
      "ok-disabled": _vm.periodBoletos.loading,
      "cancel-disabled": _vm.periodBoletos.loading,
      "busy": _vm.periodBoletos.loading,
      "ok-title": _vm.periodBoletos.loading ? 'Gerando...' : 'Gerar boletos',
      "ok-variant": "primary",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleGeneratePeriodBoletos.apply(null, arguments);
      },
      "hidden": _vm.resetPeriodBoletosModal
    }
  }, [_vm.periodBoletos.contrato ? _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" Contrato "), _c('strong', [_vm._v("#" + _vm._s(_vm.periodBoletos.contrato.numero))]), _vm._v(" · " + _vm._s(_vm.periodBoletos.contrato.cliente) + " ")]) : _vm._e(), _vm.periodBoletos.contrato ? _c('div', {
    staticClass: "alert alert-light-primary mb-2"
  }, [_vm._v(" Serão gerados os boletos mensais com vencimento após o início da vigência ("), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.periodBoletos.contrato.data_inicio)))]), _vm._v(") e até "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.periodBoletos.contrato.data_termino)))]), _vm._v(". ")]) : _vm._e(), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Boletos já existentes serão mantidos. A rotina mensal continuará gerando somente a NFS-e de cada mês. ")])]), _c('b-modal', {
    attrs: {
      "id": "send-contract-invoice-modal",
      "title": "Enviar fatura",
      "centered": "",
      "ok-disabled": _vm.invoiceEmail.loading || _vm.invoiceEmail.sending || !_vm.isInvoiceEmailValid || !_vm.invoiceEmail.hasDocuments,
      "cancel-disabled": _vm.invoiceEmail.sending,
      "busy": _vm.invoiceEmail.sending,
      "ok-title": _vm.invoiceEmail.sending ? 'Enviando...' : 'Enviar fatura',
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleSendInvoiceEmail.apply(null, arguments);
      },
      "hidden": _vm.resetInvoiceEmailModal
    }
  }, [_vm.invoiceEmail.contrato ? _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v(" Contrato #" + _vm._s(_vm.invoiceEmail.contrato.numero) + " · " + _vm._s(_vm.invoiceEmail.contrato.cliente) + " ")]) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Competência",
      "label-for": "invoice-email-competencia"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "invoice-email-competencia",
      "type": "month",
      "disabled": _vm.invoiceEmail.loading || _vm.invoiceEmail.sending
    },
    on: {
      "change": function change($event) {
        return _vm.loadInvoiceEmailPreview(false);
      }
    },
    model: {
      value: _vm.invoiceEmail.competencia,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceEmail, "competencia", $$v);
      },
      expression: "invoiceEmail.competencia"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "E-mail de destino",
      "label-for": "invoice-email-address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "invoice-email-address",
      "type": "email",
      "placeholder": "cliente@empresa.com",
      "disabled": _vm.invoiceEmail.sending
    },
    model: {
      value: _vm.invoiceEmail.email,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceEmail, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "invoiceEmail.email"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("O e-mail do contrato já vem preenchido, mas pode ser alterado para este envio.")])], 1), _vm.invoiceEmail.loading ? _c('div', {
    staticClass: "text-muted py-2"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Consultando documentos... ")], 1) : _vm.invoiceEmail.loadError ? _c('div', {
    staticClass: "alert alert-danger mb-0"
  }, [_vm._v(" " + _vm._s(_vm.invoiceEmail.loadError) + " ")]) : !_vm.invoiceEmail.hasDocuments ? _c('div', {
    staticClass: "alert alert-warning mb-0"
  }, [_vm._v(" Nenhuma NFS-e ou boleto disponível nesta competência. ")]) : _c('div', {
    staticClass: "alert alert-light-primary mb-0"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Será enviado:")]), _vm.invoiceEmail.nfses.length ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.invoiceEmail.nfses.length) + " NFS-e ")]) : _vm._e(), _vm.invoiceEmail.boletos.length ? _c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.invoiceEmail.boletos.length) + " " + _vm._s(_vm.invoiceEmail.boletos.length === 1 ? "boleto" : "boletos") + " ")]) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "cancel-title": "Cancelar",
      "id": "confirm-ativar-licenca",
      "title": "Confirmar ativação da conta",
      "centered": "",
      "ok-disabled": !_vm.licencaForm.plano || _vm.confirmLoading,
      "ok-title": _vm.confirmLoading ? 'Ativando...' : 'Sim, ativar',
      "ok-variant": "success",
      "cancel-disabled": _vm.confirmLoading,
      "busy": _vm.confirmLoading
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleConfirmAtivarLicenca.apply(null, arguments);
      },
      "hidden": function hidden($event) {
        _vm.licencaForm.plano = null;
      }
    }
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Tem certeza que deseja ativar a licença do "), _c('strong', [_vm._v(" " + _vm._s((_vm$firstSelected = _vm.firstSelected) === null || _vm$firstSelected === void 0 ? void 0 : _vm$firstSelected.cliente) + " — " + _vm._s(_vm.maskDoc((_vm$firstSelected2 = _vm.firstSelected) === null || _vm$firstSelected2 === void 0 ? void 0 : _vm$firstSelected2.cnpj_cpf)) + " ")]), _vm._v(" por mais 1 ano? ")]), _c('b-form-group', {
    attrs: {
      "label": "Plano da licença"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.planoOptions,
      "placeholder": "Selecione um plano"
    },
    model: {
      value: _vm.licencaForm.plano,
      callback: function callback($$v) {
        _vm.$set(_vm.licencaForm, "plano", $$v);
      },
      expression: "licencaForm.plano"
    }
  })], 1)], 1), _c('div', {
    staticClass: "card-body p-0"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.rows,
      "fields": _vm.fields,
      "busy": _vm.loading,
      "hover": "",
      "responsive": "",
      "primary-key": "id_contrato_fatura",
      "head-variant": "light",
      "no-local-sorting": true,
      "sort-by": _vm.sort.field,
      "sort-desc": _vm.sort.typeDesc,
      "tbody-tr-class": _vm.rowClass,
      "show-empty": true
    },
    on: {
      "sort-changed": _vm.onSortChanged,
      "update:sortBy": function updateSortBy($event) {
        return _vm.$set(_vm.sort, "field", $event);
      },
      "update:sort-by": function updateSortBy($event) {
        return _vm.$set(_vm.sort, "field", $event);
      },
      "update:sortDesc": function updateSortDesc($event) {
        return _vm.$set(_vm.sort, "typeDesc", $event);
      },
      "update:sort-desc": function updateSortDesc($event) {
        return _vm.$set(_vm.sort, "typeDesc", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center p-5"
        }, [_vm._v("Carregando...")])];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted py-5"
        }, [_c('i', {
          staticClass: "la la-folder-open mb-2",
          staticStyle: {
            "font-size": "28px"
          }
        }), _c('div', [_vm._v("Nenhum contrato até o momento.")])])];
      },
      proxy: true
    }, {
      key: "emptyfiltered",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted py-5"
        }, [_c('i', {
          staticClass: "la la-search mb-2",
          staticStyle: {
            "font-size": "28px"
          }
        }), _c('div', [_vm._v("Nenhum contrato encontrado com os filtros atuais.")])])];
      },
      proxy: true
    }, {
      key: "head(select)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          attrs: {
            "indeterminate": _vm.someSelectedOnPage,
            "checked": _vm.allSelectedOnPage,
            "aria-label": "Selecionar todos"
          },
          on: {
            "change": _vm.toggleSelectAllOnPage
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(select)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('b-form-checkbox', {
          attrs: {
            "disabled": _vm.isRowDisabled(item),
            "checked": _vm.isRowSelected(item),
            "aria-label": "Selecionar contrato #".concat(item.numero)
          },
          on: {
            "change": function change() {
              return _vm.toggleRow(item);
            }
          }
        })];
      }
    }, {
      key: "cell(contrato)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "font-weight-600"
        }, [_vm._v(" #" + _vm._s(item.numero) + " "), _vm.currentEmpresaId == 1 ? _c('small', {
          staticClass: "text-muted ml-2 d-block"
        }, [_vm._v(" (" + _vm._s(_vm.planoDict[item.id_plano] || "—") + ") ")]) : _vm._e(), item.solicitacao_cliente ? _c('b-badge', {
          staticClass: "cursor-pointer",
          attrs: {
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirLogs(item);
            }
          }
        }, [_vm._v(" Cliente renovou ")]) : _vm._e()], 1), item.vendedor ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" Vend: " + _vm._s(item.vendedor.nome) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(cliente)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "font-weight-600"
        }, [_vm._v(_vm._s(item.cliente))]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.maskDoc(item.cnpj_cpf)))])];
      }
    }, {
      key: "cell(venda)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "font-weight-600"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(item.data_venda)) + " ")])];
      }
    }, {
      key: "cell(vigencia)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.data_inicio)) + " — " + _vm._s(_vm.formatDate(item.data_termino)) + " "), _c('div', [_c('small', {
          class: _vm.diasClasse(item.__dias)
        }, [_vm._v(_vm._s(_vm.badgeVigencia(item.__dias)))])])];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('div', [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Mensal:")]), _vm._v(" " + _vm._s(_vm.formatMoney(item.valor_total)) + " ")]), !_vm.isNuts ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_c('small', {
          staticClass: "text-muted font-weight-normal"
        }, [_vm._v("Total na vigência:")]), _vm._v(" " + _vm._s(item.__valorVigencia === null ? "—" : _vm.formatMoney(item.__valorVigencia)) + " ")]) : _vm._e(), item.taxa_implantacao && _vm.isNuts ? _c('small', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "text-muted d-inline-flex align-items-center",
          attrs: {
            "title": _vm.taxaTooltip(item)
          }
        }, [_vm._v(" " + _vm._s(item.taxa_implantacao && Number(item.taxa_implantacao) > 0 ? "Taxa: " + _vm.formatMoney(item.taxa_implantacao) : "Sem Taxa") + " "), _c('i', {
          staticClass: "la ml-1",
          class: item.gerar_boleto_taxa ? 'la-receipt text-success' : 'la-ban text-muted',
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()];
      }
    }, {
      key: "cell(status)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.statusVariant(item.status)
          }
        }, [_vm._v(_vm._s(_vm.mapStatus(item.status)))])];
      }
    }, {
      key: "cell(cobranca)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('div', {
          staticClass: "d-flex align-items-center flex-wrap gap-6"
        }, [_c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip(item.emitir_nfse ? 'Emite NFS-e' : 'Não emite NFS-e'),
            expression: "contractTooltip(item.emitir_nfse ? 'Emite NFS-e' : 'Não emite NFS-e')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": item.emitir_nfse ? 'success' : 'secondary',
            "pill": ""
          }
        }, [_vm._v(" NFSe ")]), _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip(item.emitir_boletos ? 'Emite boletos' : 'Não emite boletos'),
            expression: "contractTooltip(item.emitir_boletos ? 'Emite boletos' : 'Não emite boletos')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": item.emitir_boletos ? 'primary' : 'secondary',
            "pill": ""
          }
        }, [_vm._v(" Boleto ")]), _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip("Cobran\xE7a no dia ".concat(item.dia_cobranca || '-', " de cada m\xEAs")),
            expression: "contractTooltip(`Cobrança no dia ${item.dia_cobranca || '-'} de cada mês`)"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "info",
            "pill": ""
          }
        }, [_vm._v(" Dia " + _vm._s(item.dia_cobranca || "-") + " ")]), _vm.currentEmpresaId !== 1 ? _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip("Envio da fatura no dia ".concat(item.dia_envio_fatura || 1, " de cada m\xEAs")),
            expression: "contractTooltip(`Envio da fatura no dia ${item.dia_envio_fatura || 1} de cada mês`)"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "dark",
            "pill": ""
          }
        }, [_vm._v(" Envio " + _vm._s(item.dia_envio_fatura || 1) + " ")]) : _vm._e(), item.cobranca_anual ? _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Gera todos os boletos do contrato'),
            expression: "contractTooltip('Gera todos os boletos do contrato')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "warning",
            "pill": ""
          }
        }, [_vm._v(" Cobrança Anual ")]) : _vm._e(), item.plugin_certificado && _vm.currentEmpresaId == 1 ? _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Contrato com Certificado Digital A1'),
            expression: "contractTooltip('Contrato com Certificado Digital A1')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "dark",
            "pill": ""
          }
        }, [_vm._v(" Certificado ")]) : _vm._e(), item.plugin_tef && _vm.currentEmpresaId == 1 ? _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Contrato com TEF Integrado'),
            expression: "contractTooltip('Contrato com TEF Integrado')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "dark",
            "pill": ""
          }
        }, [_vm._v(" TEF ")]) : _vm._e(), item.carne_asaas ? _c('b-badge', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Carnê completo disponível'),
            expression: "contractTooltip('Carnê completo disponível')"
          }],
          staticClass: "mr-2 mb-1",
          attrs: {
            "variant": "success",
            "pill": ""
          }
        }, [_c('a', {
          staticClass: "text-white",
          staticStyle: {
            "text-decoration": "none"
          },
          attrs: {
            "href": item.carne_asaas,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" Carnê ")])]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm.canExecuteContract(item) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Executar contrato agora'),
            expression: "contractTooltip('Executar contrato agora')"
          }],
          staticClass: "btn btn-xs btn-success btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Executar contrato agora"
          },
          on: {
            "click": function click($event) {
              return _vm.openExecuteModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-play",
          staticStyle: {
            "font-size": "15px"
          }
        })]) : _vm._e(), _vm.canGeneratePeriodBoletos(item) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Gerar boletos de todo o período'),
            expression: "contractTooltip('Gerar boletos de todo o período')"
          }],
          staticClass: "btn btn-xs btn-outline-primary btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Gerar boletos de todo o período"
          },
          on: {
            "click": function click($event) {
              return _vm.openPeriodBoletosModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-calendar-plus-o",
          staticStyle: {
            "font-size": "16px"
          }
        })]) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Histórico de execuções'),
            expression: "contractTooltip('Histórico de execuções')"
          }],
          staticClass: "btn btn-xs btn-outline-info btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Histórico de execuções"
          },
          on: {
            "click": function click($event) {
              return _vm.openExecutionHistory(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-history",
          staticStyle: {
            "font-size": "16px"
          }
        })]), item.nfses.length ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Ver NFS-e do contrato'),
            expression: "contractTooltip('Ver NFS-e do contrato')"
          }],
          staticClass: "btn btn-xs btn-outline-primary btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Ver NFS-e do contrato"
          },
          on: {
            "click": function click($event) {
              return _vm.openNfseModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-file-invoice-dollar",
          staticStyle: {
            "font-size": "16px"
          }
        })]) : _vm._e(), Array.isArray(item.boletos) && item.boletos.length ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Ver boletos do contrato'),
            expression: "contractTooltip('Ver boletos do contrato')"
          }],
          staticClass: "btn btn-xs btn-outline-secondary btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Ver boletos do contrato"
          },
          on: {
            "click": function click($event) {
              return _vm.openBoletosModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-barcode",
          staticStyle: {
            "font-size": "16px"
          }
        })]) : _vm._e(), item.emitir_nfse || item.emitir_boletos || Array.isArray(item.nfses) && item.nfses.length || Array.isArray(item.boletos) && item.boletos.length ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Enviar documentos da fatura por e-mail'),
            expression: "contractTooltip('Enviar documentos da fatura por e-mail')"
          }],
          staticClass: "btn btn-xs btn-outline-success btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Enviar documentos da fatura por e-mail"
          },
          on: {
            "click": function click($event) {
              return _vm.openInvoiceEmailModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-envelope",
          staticStyle: {
            "font-size": "16px"
          }
        })]) : _vm._e(), [1, 2].includes(Number(item.status)) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Editar contrato'),
            expression: "contractTooltip('Editar contrato')"
          }],
          staticClass: "btn btn-xs btn-info btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Editar contrato"
          },
          on: {
            "click": function click($event) {
              return _vm.editarContrato(item);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 10
          }
        })], 1) : _vm._e(), item.status === 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Excluir contrato'),
            expression: "contractTooltip('Excluir contrato')"
          }],
          staticClass: "btn btn-xs btn-danger btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Excluir contrato"
          },
          on: {
            "click": function click($event) {
              return _vm.excluir(item);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: _vm.contractTooltip('Visualizar contrato'),
            expression: "contractTooltip('Visualizar contrato')"
          }],
          staticClass: "btn btn-xs btn-outline-dark btn-icon p-0 mr-1",
          attrs: {
            "aria-label": "Visualizar contrato"
          },
          on: {
            "click": function click($event) {
              return _vm.openContratoModal(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-eye",
          staticStyle: {
            "font-size": "16px"
          }
        })])];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "contrato-view-modal",
      "title": _vm.contratoModalTitle,
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetContratoModal
    }
  }, [_vm.modalContrato.loading ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "22px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "22px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "22px"
    }
  })], 1) : !_vm.modalContrato.data ? _c('div', {
    staticClass: "text-muted text-center py-4"
  }, [_vm._v(" Não foi possível carregar este contrato. ")]) : _c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-start mb-3"
  }, [_c('div', [_c('div', {
    staticClass: "h5 mb-1"
  }, [_vm._v(" #" + _vm._s(_vm.modalContrato.data.numero) + " "), _vm.currentEmpresaId == 1 ? _c('small', {
    staticClass: "text-muted ml-2"
  }, [_vm._v(" (" + _vm._s(_vm.planoDict[_vm.modalContrato.data.id_plano] || "—") + ") ")]) : _vm._e()]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.modalContrato.data.cliente.nome) + " — " + _vm._s(_vm.maskDoc(_vm.modalContrato.data.cnpj_cpf)) + " ")])]), _c('b-badge', {
    attrs: {
      "variant": _vm.statusVariant(_vm.modalContrato.data.status)
    }
  }, [_vm._v(" " + _vm._s(_vm.mapStatus(_vm.modalContrato.data.status)) + " ")])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Data da venda")]), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.modalContrato.data.data_venda)) + " ")])]), _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Vigência")]), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.modalContrato.data.data_inicio)) + " — " + _vm._s(_vm.formatDate(_vm.modalContrato.data.data_termino)) + " ")]), _c('small', {
    class: _vm.diasClasse(_vm.modalContrato.data.__dias)
  }, [_vm._v(" " + _vm._s(_vm.badgeVigencia(_vm.modalContrato.data.__dias)) + " ")])]), _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Dia de cobrança")]), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(" Dia " + _vm._s(_vm.modalContrato.data.dia_cobranca || "-") + " ")])]), _vm.currentEmpresaId !== 1 ? _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Dia de envio da fatura")]), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(" Dia " + _vm._s(_vm.modalContrato.data.dia_envio_fatura || 1) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Valor total")]), _c('div', {
    staticClass: "h6 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.formatMoney(_vm.modalContrato.data.valor_total)) + " ")])]), _vm.isNuts ? _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Taxa de implantação")]), _c('div', {
    staticClass: "h6 mb-0 d-flex align-items-center"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.modalContrato.data.taxa_implantacao && Number(_vm.modalContrato.data.taxa_implantacao) > 0 ? _vm.formatMoney(_vm.modalContrato.data.taxa_implantacao) : "—") + " ")]), _c('i', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "la ml-1",
    class: _vm.modalContrato.data.gerar_boleto_taxa ? 'la-receipt text-success' : 'la-ban text-muted',
    attrs: {
      "title": _vm.taxaTooltip(_vm.modalContrato.data)
    }
  })])]) : _vm._e(), _vm.modalContrato.data.plugin_certificado ? _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Certificado Digital")]), _c('div', {
    staticClass: "h6 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.formatMoney(_vm.modalContrato.data.valor_certificado || 0)) + " ")])]) : _vm._e(), _vm.modalContrato.data.plugin_tef ? _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("TEF Integrado")]), _c('div', {
    staticClass: "h6 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.formatMoney(_vm.modalContrato.data.valor_tef || 0)) + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }, [_c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": _vm.modalContrato.data.emitir_nfse ? 'success' : 'secondary',
      "pill": ""
    }
  }, [_vm._v(" NFSe ")]), _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": _vm.modalContrato.data.emitir_boletos ? 'primary' : 'secondary',
      "pill": ""
    }
  }, [_vm._v(" Boleto ")]), _vm.modalContrato.data.cobranca_anual ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "warning",
      "pill": ""
    }
  }, [_vm._v(" Cobrança Anual ")]) : _vm._e(), _vm.modalContrato.data.carne_asaas ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "pill": ""
    }
  }, [_c('a', {
    staticClass: "text-white",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.modalContrato.data.carne_asaas,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Carnê ")])]) : _vm._e(), _vm.modalContrato.data.link_fatura ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "info",
      "pill": ""
    }
  }, [_c('a', {
    staticClass: "text-white",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.modalContrato.data.link_fatura,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Fatura ")])]) : _vm._e(), _vm.modalContrato.data.pular_final_semana ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "warning",
      "pill": ""
    }
  }, [_vm._v(" Pular finais semana ")]) : _vm._e(), _vm.modalContrato.data.plugin_certificado ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "dark",
      "pill": ""
    }
  }, [_vm._v(" Certificado ")]) : _vm._e(), _vm.modalContrato.data.plugin_tef ? _c('b-badge', {
    staticClass: "mr-2",
    attrs: {
      "variant": "dark",
      "pill": ""
    }
  }, [_vm._v(" TEF ")]) : _vm._e()], 1), _vm.modalContrato.data.observacao ? _c('div', {
    staticClass: "border rounded p-3 mb-4 bg-light"
  }, [_c('small', {
    staticClass: "text-muted d-block mb-1"
  }, [_vm._v("Observação")]), _c('div', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s(_vm.modalContrato.data.observacao) + " ")])]) : _vm._e(), _vm.pagamentosContrato.length ? _c('div', {
    staticClass: "mb-4"
  }, [_c('small', {
    staticClass: "text-muted d-block mb-2"
  }, [_vm._v("Forma de pagamento")]), _vm._l(_vm.pagamentosContrato, function (pagamento, index) {
    return _c('div', {
      key: index,
      staticClass: "border rounded p-3 mb-3"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4 mb-3"
    }, [_c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v("Descrição")]), _c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v(" " + _vm._s(pagamento.descricao || "—") + " ")])]), _c('div', {
      staticClass: "col-md-2 mb-3"
    }, [_c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v("Parcelas")]), _c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v(" " + _vm._s(pagamento.vezes || "—") + " ")])]), _c('div', {
      staticClass: "col-md-3 mb-3"
    }, [_c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v("Periodicidade")]), _c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v(" " + _vm._s(_vm.getPeriodicidadePagamento(pagamento.intervalo_dias || pagamento.intervalo_dias_collection)) + " ")])])]), Array.isArray(pagamento.range) && pagamento.range.length ? _c('div', {
      staticClass: "mt-2"
    }, [_c('small', {
      staticClass: "text-muted d-block mb-2"
    }, [_vm._v("Parcelas previstas")]), _c('b-table', {
      attrs: {
        "items": pagamento.range.map(function (item, i) {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: i + 1
          });
        }),
        "fields": _vm.pagamentosFields,
        "small": "",
        "bordered": "",
        "responsive": "",
        "head-variant": "light"
      },
      scopedSlots: _vm._u([{
        key: "cell(id)",
        fn: function fn(_ref0) {
          var item = _ref0.item;
          return [_vm._v(" " + _vm._s(item.id) + " ")];
        }
      }, {
        key: "cell(date)",
        fn: function fn(_ref1) {
          var item = _ref1.item;
          return [_vm._v(" " + _vm._s(_vm.formatDate(item.date)) + " ")];
        }
      }, {
        key: "cell(value)",
        fn: function fn(_ref10) {
          var item = _ref10.item;
          return [_vm._v(" " + _vm._s(_vm.formatMoney(item.value)) + " ")];
        }
      }], null, true)
    })], 1) : _vm._e()]);
  })], 2) : _vm._e()])]), _c('b-modal', {
    attrs: {
      "id": "execution-history-modal",
      "title": _vm.executionHistoryTitle,
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetExecutionHistory
    }
  }, [_vm.executionHistory.loading ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  })], 1) : _c('b-table', {
    attrs: {
      "items": _vm.executionHistory.items,
      "fields": _vm.executionHistoryFields,
      "small": "",
      "responsive": "",
      "head-variant": "light",
      "show-empty": "",
      "empty-text": "Nenhuma execução registrada para este contrato."
    },
    scopedSlots: _vm._u([{
      key: "cell(executado_em)",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_vm._v(" " + _vm._s(_vm.formatDateTime(item.executado_em)) + " ")];
      }
    }, {
      key: "cell(competencia)",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_vm._v(" " + _vm._s(_vm.formatCompetencia(item.competencia)) + " ")];
      }
    }, {
      key: "cell(origem)",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_vm._v(" " + _vm._s(item.origem === "manual" ? "Manual" : "Automática") + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.executionStatusVariant(item.status)
          }
        }, [_vm._v(" " + _vm._s(_vm.executionStatusLabel(item.status)) + " ")])];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [_vm._v(" " + _vm._s(_vm.formatMoney(item.valor)) + " ")];
      }
    }, {
      key: "cell(usuario)",
      fn: function fn(_ref16) {
        var _item$usuario;
        var item = _ref16.item;
        return [_vm._v(" " + _vm._s(((_item$usuario = item.usuario) === null || _item$usuario === void 0 ? void 0 : _item$usuario.nome) || "Sistema") + " ")];
      }
    }, {
      key: "cell(mensagem)",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [_c('span', {
          attrs: {
            "title": item.mensagem
          }
        }, [_vm._v(_vm._s(item.mensagem || "—"))])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-logs-renovacao",
      "title": "Histórico de Renovações pelo Cliente",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('b-table', {
    attrs: {
      "items": _vm.tabelaLogs,
      "fields": _vm.camposLogs,
      "small": "",
      "bordered": "",
      "hover": "",
      "head-variant": "light",
      "sticky-header": "50vh",
      "show-empty": "",
      "empty-text": "Sem registros de renovação."
    },
    scopedSlots: _vm._u([{
      key: "cell(ano_referencia)",
      fn: function fn(_ref18) {
        var item = _ref18.item;
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(item.ano_referencia))])];
      }
    }, {
      key: "cell(data_renovacao)",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatDate(item.data_renovacao)))])];
      }
    }, {
      key: "cell(canal)",
      fn: function fn(_ref20) {
        var item = _ref20.item;
        return [item.canal ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(_vm._s(item.canal))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("—")])];
      }
    }, {
      key: "cell(usuario_nome)",
      fn: function fn(_ref21) {
        var item = _ref21.item;
        return [_vm._v(" " + _vm._s(item.usuario_nome || "—") + " ")];
      }
    }, {
      key: "cell(usuario_email)",
      fn: function fn(_ref22) {
        var item = _ref22.item;
        return [item.usuario_email ? _c('a', {
          attrs: {
            "href": "mailto:".concat(item.usuario_email)
          }
        }, [_vm._v(_vm._s(item.usuario_email))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("—")])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "nfse-list-modal",
      "title": _vm.modalNfseTitle,
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetNfseModal
    }
  }, [_vm.modalNfse.loading ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  })], 1) : _c('div', [!_vm.modalNfse.notas.length ? _c('div', {
    staticClass: "text-muted text-center py-4"
  }, [_vm._v(" Nenhuma NFSe encontrada para este contrato. ")]) : _c('b-table', {
    attrs: {
      "items": _vm.modalNfse.notas,
      "fields": _vm.nfseFields,
      "small": "",
      "responsive": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "cell(total_nfse)",
      fn: function fn(_ref23) {
        var item = _ref23.item;
        return [_vm._v(" " + _vm._s(_vm.formatMoney(item.total_nfse)) + " ")];
      }
    }, {
      key: "cell(emissao)",
      fn: function fn(_ref24) {
        var item = _ref24.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.emissao)) + " ")];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(_ref25) {
        var item = _ref25.item;
        return [_c('div', {
          staticClass: "d-flex flex-wrap justify-content-end"
        }, [_c('b-button', {
          staticClass: "mr-2 mb-1",
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": _vm.printingId === item.id_nfse || !item.nfse_url && _vm.loadingPrint
          },
          on: {
            "click": function click($event) {
              return _vm.handleImprimirNFSe(item);
            }
          }
        }, [_vm.printingId === item.id_nfse ? _c('b-spinner', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }) : _c('i', {
          staticClass: "la la-print mr-1"
        }), _vm._v(" " + _vm._s(_vm.printingId === item.id_nfse ? "Abrindo..." : "NFSe") + " ")], 1), Array.isArray(item.boletos) && item.boletos.length ? _vm._l(item.boletos, function (b, idx) {
          var _b$id;
          return _c('b-button', {
            key: (_b$id = b.id) !== null && _b$id !== void 0 ? _b$id : idx,
            staticClass: "mr-2 mb-1",
            attrs: {
              "size": "sm",
              "variant": "outline-secondary",
              "disabled": !b.url
            },
            on: {
              "click": function click($event) {
                return _vm.abrirBoleto(b);
              }
            }
          }, [_c('i', {
            staticClass: "la la-barcode mr-1"
          }), _vm._v(" " + _vm._s(b.doc) + " — " + _vm._s(b.vencimento) + " ")]);
        }) : _c('b-badge', {
          staticClass: "mb-1",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("Sem boletos")])], 2)];
      }
    }])
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "boletos-list-modal",
      "title": _vm.boletosModalTitle,
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetBoletosModal
    }
  }, [_vm.modalBoletos.loading ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "28px"
    }
  })], 1) : _c('div', [!Array.isArray(_vm.modalBoletos.itens) || !_vm.modalBoletos.itens.length ? _c('div', {
    staticClass: "text-muted text-center py-4"
  }, [_vm._v(" Nenhum boleto encontrado para este contrato. ")]) : _c('b-table', {
    attrs: {
      "items": _vm.modalBoletos.itens,
      "fields": _vm.boletosFields,
      "small": "",
      "responsive": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "cell(valor)",
      fn: function fn(_ref26) {
        var item = _ref26.item;
        return [_vm._v(" " + _vm._s(_vm.formatMoney(item.valor)) + " ")];
      }
    }, {
      key: "cell(recebido)",
      fn: function fn(_ref27) {
        var item = _ref27.item;
        return [_c('b-badge', {
          attrs: {
            "variant": item.recebido ? 'success' : 'secondary'
          }
        }, [_vm._v(" " + _vm._s(item.recebido ? "Recebido" : "Pendente") + " ")])];
      }
    }, {
      key: "cell(data_vencimento)",
      fn: function fn(_ref28) {
        var item = _ref28.item;
        return [_vm._v(" " + _vm._s(item.vencimento) + " ")];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(_ref29) {
        var item = _ref29.item;
        return [_c('div', {
          staticClass: "d-flex justify-content-end"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-secondary",
            "disabled": !item.url
          },
          on: {
            "click": function click($event) {
              return _vm.abrirBoleto(item);
            }
          }
        }, [_c('i', {
          staticClass: "la la-barcode mr-1"
        }), _vm._v(" Abrir ")])], 1)];
      }
    }])
  })], 1)]), _vm.isNuts ? _c('b-modal', {
    attrs: {
      "id": "taxa-boleto-modal",
      "title": _vm.taxaModalTitle,
      "size": "md",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetTaxaModal
    }
  }, [_vm.modalTaxa.loading ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "24px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "24px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-2",
    attrs: {
      "height": "24px"
    }
  })], 1) : _c('div', [!_vm.modalTaxa.boleto ? _c('div', {
    staticClass: "text-muted text-center py-4"
  }, [_vm._v(" Nenhum boleto de taxa encontrado para este contrato. ")]) : _c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v("Taxa de implantação")]), _c('b-badge', {
    attrs: {
      "variant": _vm.modalTaxa.boleto.recebido ? 'success' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.modalTaxa.boleto.recebido ? "Recebido" : "Pendente") + " ")])], 1), _c('div', {
    staticClass: "mb-1"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Valor")]), _c('div', {
    staticClass: "h5 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.formatMoney(_vm.modalTaxa.boleto.valor)) + " ")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Vencimento")]), _c('div', {
    staticClass: "h6 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.modalTaxa.boleto.data_vencimento) + " ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "disabled": !_vm.modalTaxa.boleto.url_boleto,
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirBoleto({
          url: _vm.modalTaxa.boleto.url_boleto
        });
      }
    }
  }, [_c('i', {
    staticClass: "la la-barcode mr-2"
  }), _vm._v(" Abrir boleto ")]), _vm.modalTaxa.boleto.carnet_url ? _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.window.open(_vm.modalTaxa.boleto.carnet_url, '_blank', 'noopener');
      }
    }
  }, [_c('i', {
    staticClass: "la la-file-pdf-o mr-2"
  }), _vm._v(" Carnê ")]) : _vm._e()], 1)])])]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center px-4 py-3"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total: " + _vm._s(_vm.pagination.total))]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": [10, 20, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.changePerPage
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  }), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.total,
      "per-page": _vm.perPage,
      "size": "sm"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };